import React, { useState, useEffect, useRef } from "react";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
// import VscTwitter from "react-icons/vsc";
import { FaTwitter } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import "./navbar.css";
import utopiaClearLogo from "../../assets/icons/utopiaClearLogo.png";
import { NavLink, useLocation, Link, useNavigate } from "react-router-dom";
import Burger from "../mobileNav/Burger";
import triumphant_logoC from "../../assets/images/triumphant_logoC.png";

const Navbar = () => {
  useEffect(() => {
    const changeWidth = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", changeWidth);

    return () => {
      window.removeEventListener("resize", changeWidth);
    };
  }, []);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [switchSmallNav, setSwitchSmallNav] = useState(false);

  const switchHandler = () => {
    setSwitchSmallNav(true);
  };
  const location = useLocation();
  const navigate = useNavigate();

  const { pathname } = location;

  const splitLocation = pathname.split("/");

  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null); // Add this line
  // Add this useEffect
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);
  const showDropdown = (e) => {
    setShow(!show);
  };
  const inSide = (e) => {
    setShow(true);
  };
  const hideDropdown = (e) => {
    setShow(false);
  };

  const greLink = () => {
    navigate("/gre_page");
    showDropdown();
  };
  const gmatLink = () => {
    navigate("/gmat_page");
    showDropdown();
  };
  const pteLink = () => {
    navigate("/pte_page");
    showDropdown();
  };
  const toeflLink = () => {
    navigate("/toefl_page");
    showDropdown();
  };
  const ieltsLink = () => {
    navigate("/ielts_page");
    showDropdown();
  };

  const satLink = () => {
    navigate("/sat_page");
    showDropdown();
  };

  const portalUrl =
    "https://jcard.icrystal.org.ng/mySchool_login?cboSchool=TRIUMPHANT%20JUMAK%20COMPREHENSIVE%20COLLEGE";

  return (
    <div className="maxWidthStyle">
      {screenWidth < 992 && (
        <div className="mobilenavbar-optMenuFam">
          <Link
            to="/"
            className="mobilenavbar-optMenulogo"
            style={{ textDecoration: "none" }}
          >
            <img src={triumphant_logoC} />
          </Link>
          <div>
            <Burger />
          </div>
        </div>
      )}
      <div className="navbar-infoFamFlex">
        <div className="navbar-infoNumber">
          CALL US:07030916267, 09020174506, 08091609312
        </div>
        <div className="navbar-infoIconsFam">
          <a
            aria-label="Chat on WhatsApp"
            href="https://www.instagram.com/utopiaconsulthq/"
            style={{ textDecoration: "none", cursor: "pointer" }}
            target="_blank"
          >
            <div className="navbar-infoIconEach">
              <FaInstagram />
            </div>
          </a>
          <a
            aria-label="Chat on WhatsApp"
            href="https://wa.me/2347030916267"
            style={{ textDecoration: "none", cursor: "pointer" }}
            target="_blank"
          >
            <div className="navbar-infoIconEach">
              <FaWhatsapp />
            </div>
          </a>
          <a
            aria-label="Chat on WhatsApp"
            href="https://twitter.com/utopiaconsulthq"
            style={{ textDecoration: "none", cursor: "pointer" }}
            target="_blank"
          >
            <div className="navbar-infoIconEach">
              <FaTwitter />
            </div>
          </a>

          <div className="navbar-infoIconEach">
            <FaLinkedin />
          </div>

          <a
            aria-label="Chat on WhatsApp"
            href="https://web.facebook.com/people/Triumphant-jumak-Schools/100092976781906/"
            style={{ textDecoration: "none", cursor: "pointer" }}
            target="_blank"
          >
            <div className="navbar-infoIconEach">
              <FaFacebookSquare />
            </div>
          </a>
        </div>
      </div>

      {screenWidth > 992 && (
        <div className="navbar-optMenuFam">
          <Link
            to="/"
            className="navbar-optMenulogo"
            style={{ textDecoration: "none" }}
          >
            <img src={triumphant_logoC} />
          </Link>

          <Link
            to="/"
            className={
              splitLocation[1] === "" ? "activeHeader" : "navbar-optMenuopt"
            }
            style={{ textDecoration: "none" }}
          >
            HOME
          </Link>
          <Link
            to="/about_us"
            className={
              splitLocation[1] === "about_us"
                ? "activeHeader"
                : "navbar-optMenuopt"
            }
            style={{ textDecoration: "none" }}
          >
            ABOUT US
          </Link>
          <div ref={dropdownRef}>
            {" "}
            {/* Add ref to this div */}
            <div
              onClick={showDropdown}
              className="navbar-optMenuopt navbar-optMenuoptExamm"
            >
              PORTAL <FaAngleDown className="navbar-optMenuoptExamArr" />
            </div>
            {show && (
              <div className="navbar-ExamMenuFam">
                <div
                  onClick={() => window.open(portalUrl, "_blank")}
                  className="navbar-ExamMenuOpt"
                >
                  <p>College</p>
                </div>
                <div
                  onClick={() => window.open(portalUrl, "_blank")}
                  className="navbar-ExamMenuOpt"
                >
                  <p>Primary</p>
                </div>
                <div
                  onClick={() => window.open(portalUrl, "_blank")}
                  className="navbar-ExamMenuOpt"
                >
                  <p>Creche/Nursery</p>
                </div>
                <div
                  onClick={() => window.open(portalUrl, "_blank")}
                  className="navbar-ExamMenuOpt"
                >
                  <p>Parent/Guardian</p>
                </div>
              </div>
            )}
          </div>
          <Link
            to="/gallery_page"
            className={
              splitLocation[1] === "gallery_page"
                ? "activeHeader"
                : "navbar-optMenuopt"
            }
            style={{ textDecoration: "none" }}
          >
            GALLERY
          </Link>
          {/* <Link
            to="/admission_page"
            className={
              splitLocation[1] === "admission_page"
                ? "activeHeader"
                : "navbar-optMenuopt"
            }
            style={{ textDecoration: "none" }}
          >
            ADMISSION PROCESS
          </Link> */}
          {/* <Link
            to="/training"
            className={
              splitLocation[1] === "training"
                ? "activeHeader"
                : "navbar-optMenuopt"
            }
            style={{ textDecoration: "none" }}
          >
            TRAINING CENTER
          </Link> */}
          <Link
            to="/contact_page"
            className={
              splitLocation[1] === "contact_page"
                ? "activeHeader"
                : "navbar-optMenuopt"
            }
            style={{ textDecoration: "none" }}
          >
            CONTACT US
          </Link>
        </div>
      )}
    </div>
  );
};

export default Navbar;
